import { NestedActionContainer } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import styles from './VerticalEventCard.module.scss';

const cx = classNames.bind(styles);

interface VerticalEventCardProps {
    isRaised?: boolean;
    actionVisibility?: 'hidden' | 'visible';
    fullClick?: boolean;
}

const ELEVATION = '0px 2px 8px rgba(30, 10, 60, 0.06), 0px 4px 12px rgba(30, 10, 60, 0.08)';

export const VerticalEventCard = (props: React.PropsWithChildren<VerticalEventCardProps>) => {
    const elevation = props.isRaised ? ELEVATION : undefined;

    const verticalEventCardClasses = cx(styles['event-card'], styles['event-card__vertical'], {
        [styles['vertical-event-card__action-visibility']!]: props.actionVisibility === 'hidden',
        [styles['event-card__vertical__action-visibility--raised']!]:
            props.actionVisibility === 'hidden' && props.isRaised,
        [styles['event-card__full-card-click']!]: props.fullClick,
    });

    return (
        <NestedActionContainer
            tokens={{
                '--ContainerElevation': elevation,
            }}
            className={verticalEventCardClasses}
        >
            {props.children}
        </NestedActionContainer>
    );
};
